export default __webpack_public_path__ + "static/media/ic-close-black.1dd45064.svg";